import MasterDeliverySliders from './MasterDeliverySliders'
export default MasterDeliverySliders
